import { faShop } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

type MerchantIdCardsHeaderProps = Readonly<{
    subtitleElement?: JSX.Element
    hideNavGroupCrumb?: boolean
}>

export function MerchantIdCardsHeader({ subtitleElement, hideNavGroupCrumb = false }: MerchantIdCardsHeaderProps) {
    return (
        <LocalizedStrict id="merchant-reports-id-cards-title" attrs={{ title: true }}>
            <PageHeader
                page={Page.MERCHANT_ID_CARDS}
                title="ID cards"
                icon={<FontAwesomeIcon icon={faShop} />}
                subtitleElement={subtitleElement}
            >
                <StandardBreadcrumbs>
                    <LocalizedStrict id="merchant-reports-id-cards-nav-item-home">
                        <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                    </LocalizedStrict>
                    {!hideNavGroupCrumb && (
                        <LocalizedStrict id="merchant-nav-item-id-cards-header">
                            <Breadcrumb>ID cards</Breadcrumb>
                        </LocalizedStrict>
                    )}
                    <LocalizedStrict id="merchant-reports-id-cards-nav-item-id-cars">
                        <Breadcrumb>ID cards</Breadcrumb>
                    </LocalizedStrict>
                </StandardBreadcrumbs>
            </PageHeader>
        </LocalizedStrict>
    )
}
